import React from 'react';

export default function PendingUserTableDeleteButton(props: { onClick: () => void }) {
    return (
        <button className='btn btn-danger btn-sm me-2' onClick={props.onClick}>
            <i className='bi bi-check2'></i> Delete Pending Account
        </button>
    );
}
